import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useBackofficeAuth } from "../context/BackofficeAuthProvider";

// Gated on the separate PlatformAdmin/admin_jwt auth realm (see BackofficeAuthProvider) —
// deliberately independent from the pharmacy useAuth()/User model.
const PlatformAdminRoute = () => {
  const { admin, loading } = useBackofficeAuth();

  if (loading) return <div><p className="text-muted">Please wait a while, Authenticating ...</p></div>;

  return admin ? <Outlet /> : <Navigate to="/backoffice/login" replace />;
};

export default PlatformAdminRoute;
